import React from "react";

export default () => {

    return <div className="loader-animation-container">
        <div className="loader-animation">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>

}
